module.exports = __webpack_public_path__ + "media/images/choose/courses_author-60fff9f74c79b28e709f77be7096f7f1.png";